import api from 'api';
import op from 'object-path';
import { useState, useEffect, useCallback } from 'react';
//import Logo from '../../images/logo.jpg';
import Logo2 from '../../images/logo_u.jpg';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { NavLink, Link } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { useActions } from 'ducks/useActions';

import Banner from '../Banner';

const Header = ({ classes, location }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteInProcess, setDeleteInProcess] = useState(false);
  const [deleteError, setDeleteError] = useState('');
  const { signOut } = useActions();
  const { isAuthorized, fullName, extended, s, petitions, rawInfo } = useSelector(
    state => state.auth
  );
  const { code: userCode } = rawInfo;

  const onResize = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const logOut = () => {
    signOut();
    setIsOpen(false);
  };

  const confirmDelete = () => {
    setDeleteDialogOpen(true);
  };

  const onDeleteConfirmationToggle = () => {
    setDeleteDialogOpen(false);
  };

  const onDeleteConfirm = async () => {
    setDeleteError('');
    setDeleteInProcess(true);
    try {
      const res = await api({
        operation: 'Auth.delete',
        ns: 'Lkk'
      });
      const isDeleted = !!res?.data?.success;
      if (!isDeleted) {
        throw new Error('Удалить аккаунт не удалось');
      }
      setIsOpen(false);
      window.location.reload();
    } catch (error) {
      const _error = error?.response?.data?.error ?? error.message;
      setDeleteError(_error);
    }
    setDeleteInProcess(false);
  };

  const isActive = (match, location) => {
    return location.pathname.includes('contract') || location.pathname === '/';
  };

  const newPetitions = petitions.filter(p => {
    const all = !!op.get(p, 'content.all');
    const list = !!op.get(p, 'content.list');
    const readers = op.get(p, 'properties.readers') || []; //prettier-ignore
    const b2cNew = !!op.get(p, 'properties.b2cNew');
    const userInReaders = !!~readers.indexOf(userCode);
    return all || list ? !userInReaders : b2cNew;
  });

  return (
    <div>
      {!!s && (
        <Alert color='danger' className='m-0'>
          Внимание, вы вошли как администратор!
        </Alert>
      )}
      <Navbar color='white' light expand='xl' className='shadow-sm mr-auto py-3'>
        <NavbarBrand href='//ulife.ru' target='_blank' rel='noopener noreferrer'>
          <img src={isAuthorized ? Logo2 : Logo2} alt="ГСК 'Югория Жизнь'" className='img-fluid' />
        </NavbarBrand>
        {isAuthorized && !!fullName && location.pathname !== '/extended' && (
          <>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar delay={{ show: 0, hide: 0 }}>
              <Nav className='mr-auto ml-0 ml-xl-5' navbar>
                <NavItem>
                  <NavLink
                    to='/'
                    className='nav-link'
                    isActive={isActive}
                    onClick={() => setIsOpen(false)}
                  >
                    Договоры страхования
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to='/me' className='nav-link' onClick={() => setIsOpen(false)}>
                    Личные данные
                    {!extended && (
                      <span className={classNames(classes.badge, 'bg-success', 'text-white')}>
                        1
                      </span>
                    )}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to='/petitions' className='nav-link' onClick={() => setIsOpen(false)}>
                    Обращения
                    {!!newPetitions.length && (
                      <span className={classNames(classes.badge, 'bg-success', 'text-white')}>
                        {newPetitions.length}
                      </span>
                    )}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to='/claim' className='nav-link' onClick={() => setIsOpen(false)}>
                    Страховой случай
                  </NavLink>
                </NavItem>
                <NavItem>
                  <a
                    href='//www.ulife.ru/payment/order/'
                    className='nav-link'
                    role='button'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Оплатить ОНЛАЙН
                  </a>
                </NavItem>
                <NavItem>
                  <a
                    href='//www.ulife.ru/company/news/'
                    className='nav-link'
                    role='button'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Новости
                  </a>
                </NavItem>
              </Nav>
              <Nav className='ml-auto' navbar>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    <span className={classNames('text-primary', classes.userInfo)}>{fullName}</span>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem to='passwd' tag={Link} onClick={() => setIsOpen(false)}>
                      Сменить пароль
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem onClick={logOut}>Выйти</DropdownItem>
                    {!s && (
                      <>
                        <DropdownItem divider />
                        <DropdownItem onClick={confirmDelete} className='text-danger'>
                          Удалить учетную запись
                        </DropdownItem>
                      </>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
            {!s && (
              <Modal
                isOpen={deleteDialogOpen}
                toggle={onDeleteConfirmationToggle}
                size='lg'
                unmountOnClose
              >
                <ModalHeader toggle={onDeleteConfirmationToggle}>
                  Вы собираетесь удалить аккаунт
                </ModalHeader>
                <ModalBody>
                  <p className='lead text-muted'>
                    <strong>
                      Уважаемый Клиент, продолжая Вы даете согласие на удаление учетной записи в
                      Личном кабинете Ю-Онлайн. Войти в Личный кабинет Ю-Онлайн можно будет только
                      после повторной регистрации. Удаление учетной записи не является отзывом
                      согласия на обработку персональных данных.
                    </strong>
                  </p>
                  {!!deleteError && <Alert color='danger'>{deleteError}</Alert>}
                </ModalBody>
                <ModalFooter>
                  <Button color='danger' onClick={onDeleteConfirm} disabled={deleteInProcess}>
                    Да, удалить
                  </Button>
                  <Button color='primary' onClick={onDeleteConfirmationToggle}>
                    Отмена
                  </Button>
                </ModalFooter>
              </Modal>
            )}
          </>
        )}
      </Navbar>
      {isAuthorized && <Banner />}
    </div>
  );
};

const styles = theme => ({
  userInfo: {
    fontSize: 16
  },
  badge: {
    display: 'inline-block',
    width: 16,
    height: 16,
    textAlign: 'center',
    lineHeight: '16px',
    fontSize: 10,
    borderRadius: '50%',
    position: 'relative',
    top: -7,
    left: 1
  },
  tempUl: {
    padding: '0',
    '& li': {
      display: 'inline',
      marginRight: 20,
      [theme.bp.down('md')]: {
        display: 'block'
      },
      fontSize: 20,
      color: 'black',
      '& a': {
        fontSize: 20,
        color: 'black'
      }
    }
  },
  tempDocs: {
    '& li': {
      '& a': {
        fontSize: 16,
        color: 'black'
      }
    }
  }
});

export default withRouter(injectSheet(styles)(Header));
